<div
  *ngIf="isOpen || keepContentVisible"
  class="accordion-wrapper"
  [@containerSlide]="isOpen"
  (@containerSlide.done)="onContainerSlideDone($event)"
>
  <ng-content />
</div>
